module.exports = __webpack_public_path__ + "img/bnb.35cdfa85.png";